import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import "swiper/css";
import "react-toastify/dist/ReactToastify.css";
import { AppProvider } from './context/AppContext';
import "@fontsource/montserrat";
import { WagmiConfig } from 'wagmi';
import { wagmiConfig } from './api/configs/wagmi';

window.Buffer = window.Buffer || require("buffer").Buffer;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <WagmiConfig config={wagmiConfig}>
        <AppProvider>
          <App />
        </AppProvider>
      </WagmiConfig>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
